export default "__VITE_ASSET__ofp_S9N$__"